import React from 'react'

const Terms = () => {
  return (
    <div>
      <iframe className="h-screen w-full" src={process.env.NEXT_PUBLIC_TERMS_URL} />
    </div>
  )
}

export default Terms
